// extracted by mini-css-extract-plugin
module.exports =  {"fa-spin":"BC3JfHrZC_sHLyyLafN3"};